import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb } from 'semantic-ui-react'
import { FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import { MappingDataContainer, MappingDataMenuContainer, MappingDataMenuButton } from './styled'
import { AdminContainer } from '../styled'
import { rootPath, adminPath, provinceDataPath, companyDataPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'

const Configuration = (props) => {
  const { history, user } = props

  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const MenuButton = (data) => {
    const { title, icon, path } = data
    return (
      <MappingDataMenuButton onClick={() => {
        if (path) {
          history.push(path)
        }
      }}>
        <Icon size='3x' icon={icon} />
        <div className='title'>{title}</div>
      </MappingDataMenuButton>
    )
  }

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Master & Mapping Data</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
              { key: 'MasterData', content: 'Master & Mapping Data', active: true }
            ]
          }
        />
      </div>
      <MappingDataContainer>
        <MappingDataMenuContainer>
          <MenuButton title='Province & Relate Data' icon='map' path={provinceDataPath} />
          <MenuButton title='Company Data' icon='hotel' path={companyDataPath} />
          {/* <MenuButton title='Maintenance Time' icon='calendar-alt' path={maintenanceTimePath} />  */}
        </MappingDataMenuContainer>
      </MappingDataContainer>
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
  })
}

const mapDispatchToProps = {
  toggleSideMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(Configuration)